import { render, staticRenderFns } from "./Confirmed.vue?vue&type=template&id=5c296472"
import script from "./Confirmed.vue?vue&type=script&lang=js"
export * from "./Confirmed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports